(function(){
  var cards = null;
  var jsonEl = document.getElementById('cards-data');
  if(jsonEl){
    try { cards = JSON.parse(jsonEl.textContent); }
    catch(e){ console.error("Ошибка парсинга JSON", e); }
  }

  var cardEl = document.getElementById('card');
  var daTextEl = document.getElementById('daText');
  var enTextEl = document.getElementById('enText');
  var playDaBtn = document.getElementById('playDa');
  var playEnBtn = document.getElementById('playEn');
  var prevBtn = document.getElementById('prevBtn');
  var nextBtn = document.getElementById('nextBtn');
  var backToDaBtn = document.getElementById('backToDa');
  var progressEl = document.getElementById('progress');

  if(!cards || !cards.length || !cardEl) return;

  var currentIndex = 0;
  var currentAudio = null;

  function updateProgress(){
    progressEl.textContent = (currentIndex+1) + " / " + cards.length;
  }

  function loadCard(i){
    var c = cards[i];
    daTextEl.textContent = c.da;
    enTextEl.textContent = c.en;
    enTextEl.style.display = "none";
    backToDaBtn.style.display = "none";
    if(currentAudio){ currentAudio.pause(); currentAudio = null; }
    updateProgress();
  }

  function playAudio(url){
    if(!url) return;
    if(currentAudio){ currentAudio.pause(); }
    currentAudio = new Audio(url);
    currentAudio.play();
  }

  playDaBtn.addEventListener("click", ()=> playAudio(cards[currentIndex].audio_da));
  playEnBtn.addEventListener("click", ()=> {
    playAudio(cards[currentIndex].audio_en);
    enTextEl.style.display = "block";
    backToDaBtn.style.display = "inline-block";
  });

  prevBtn.addEventListener("click", ()=> {
    currentIndex = (currentIndex - 1 + cards.length) % cards.length;
    loadCard(currentIndex);
  });

  nextBtn.addEventListener("click", ()=> {
    currentIndex = (currentIndex + 1) % cards.length;
    loadCard(currentIndex);
  });

  backToDaBtn.addEventListener("click", ()=> {
    enTextEl.style.display = "none";
    backToDaBtn.style.display = "none";
  });

  // первая загрузка
  loadCard(0);
})();
